<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <material-card
          color="orange"
          title="Customers"
          text="List of Registered Customers">
          <v-layout
            justify-center
            wrap>
            <v-flex
              xs12
              sm3
              md3
              offset-md9>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <v-progress-linear
            v-slot:progress
            v-if="customerListLoading"
            color="orange"
            indeterminate/>
          <v-data-table
            :headers="customerHeaders"
            :items="customers"
            :search="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <td>
                <Can
                  i="read"
                  a="customers">
                  <v-icon
                    small
                    title="View"
                    class="mr-2 ml-2"
                    color="primary"
                    flat
                    @click="editItem('view', props.item)">visibility</v-icon>
                </Can>
                <Can
                  i="write"
                  a="customers">
                  <v-icon
                    small
                    class="mr-2"
                    color="primary"
                    flat
                    @click="editItem('edit',props.item)">edit</v-icon>
                </Can>
                <Can
                  i="delete"
                  a="customers">
                  <v-icon
                    small
                    class="mr-2"
                    color="primary"
                    flat
                    @click="deleteItem(props.item)">delete</v-icon>
                </Can>
                <v-icon
                  small
                  title="Changelogs"
                  class=""
                  color="primary"
                  flat
                  @click="onShowLogs(props.item)">history</v-icon>
              </td>
              <td>{{ props.item.Customer_Name }}</td>
              <td>{{ props.item.Customer_Region }}</td>
              <td>{{ props.item.Customer_Alias }}</td>
              <td>{{ props.item.Master_Id }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  data: () => ({
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    }
  }),
  computed: {
    ...mapState('admin', ['customers', 'customerHeaders', 'customerListLoading'])
  },
  mounted () {
    this.$store.dispatch('admin/getAllCustomers', {})
  },
  methods: {
    editItem (action, item) {
      this.$store.commit('admin/clearCustomerDialog')
      this.$store.commit('admin/openCustomerDialog', {
        show: true,
        type: action,
        fields: { ...item },
        submitLabel: 'Update',
        submitHandler: (customer) => {
          this.$store.dispatch('admin/updateCustomer', customer)
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Customer_Id, changeFrom: { ...item } }, { root: true })
    },
    deleteItem (item) {
      this.$store.commit('showDialog', {
        show: true,
        yesHandler: () => {
          this.$store.dispatch('admin/deleteCustomer', item.Customer_Id)
        },
        noHandler: () => {
          this.$store.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: `Do you want to delete this Customer: ${item.Customer_Name}?`,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    },
    onShowLogs (item) {
      this.$store.dispatch('showLogRecords', item.Customer_Id)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
